<div class="app_ver_checking" *ngIf="!isLoader">
    <div class="ada">
        <div class="content_img_gt">
          <img src="../assets/images/app-version-check-image.png" alt="Update Illustration" class="illustration">
          <h2>{{appVersionData.title | uppercase}}</h2>
          <p>
            {{appVersionData.message}} 
          </p>
        </div>
        <div class="actions_th_footer">
          <button mat-flat-button class="ft2" (click)="openLink(appVersionData.download_link)">Upgrade to latest app</button>
        <div class="old_btnyt">
          <button mat-stroked-button class="ft1" (click)="continueWithThisVersion()" *ngIf="appVersionData.status == '2'">Continue with this version</button>
        </div>
        </div>
      </div>
    </div>
    
    <!-- <button style="width: 300px;" >Next</button> -->